import React from 'react';
import Cards from '../../Cards/Cards';
import {
  CARD_STYLE,
  OurServicesContainerWrapper,
  StyledCard,
  StyledConatiner,
  StyledContainer,
} from './KeyBenefits.styles';
import CategoryHeading from '../../Heading/CategoryHeading';

const KeyBenefits = ({ data }) => {
  const { headerData, content } = data;
  return (
    <StyledConatiner className='container'>
      <CategoryHeading
        headerLeftTitle={headerData?.header}
        headerRightTitle={headerData?.subHeader}
      />
      <OurServicesContainerWrapper>
        {content?.map(({ img, title, icon }, index) => {
          return (
            <StyledCard key={index}>
              <img
                className='keyBenefitImgStyle'
                src={img}
                alt='key-benefit-image'
                loading='lazy'
              />
              <StyledContainer>
                <img src={icon} alt='key-benefit-icon' loading='lazy' />
                <div className='textStyle'>{title}</div>
              </StyledContainer>
            </StyledCard>
          );
        })}
      </OurServicesContainerWrapper>
    </StyledConatiner>
  );
};

export default KeyBenefits;
